/**
 * Maps raw ACF case study data (from GraphQL) to the shape CaseStudy expects.
 */
export function mapPostToCaseStudy(raw) {
  if (!raw) return null;
  return {
    clientLabel: raw.client ?? null,
    clientLogo: raw.clientLogo ?? null,
    headline: raw.title ?? null,
    intro: raw.description ?? null,
    heroImage: raw.headerImage ?? null,
    highlightColorDark: raw.highlightColorDark ?? null,
    highlightColorLight: raw.highlightColorLight ?? null,
    ourWork: raw.ourWork ?? null,
    ourWorkFi: raw.ourWorkFi ?? null,
    ourWorkEn: raw.ourWorkEn ?? null,
    technologies: [
      raw.technology1,
      raw.technology2,
      raw.technology3,
      raw.technology4,
      raw.technology5,
      raw.technology6,
    ].filter(Boolean),
    bodyText1: raw.firstContentBox ?? null,
    bodyText2: raw.secondContentBox ?? null,
    testimonialQuote: raw.quote ?? null,
    testimonialAuthor: raw.quoter ?? null,
    testimonialTitle: null,
    featureImage: raw.dividerImage ?? null,
    summaryPoints: [
      raw.summary1,
      raw.summary2,
      raw.summary3,
      raw.summary4,
    ].filter(Boolean),
  };
}
